export default __webpack_public_path__ + "static/media/ta.ac1c95f4.mp3";